import { FormattedMessage } from 'react-intl';
import { ExternalLink, NamedLink } from '../../../../components';

export const footerSections = [
  {
    name: 'Footer.categories',
    items: [
      {
        link: (
          <NamedLink name="SearchPage" to={{ search: 'status=forSale' }}>
            <FormattedMessage id="Footer.forSale" />
          </NamedLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.vaarmarkt.nl/vaarpartners/">
            <FormattedMessage id="Footer.partners" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.nauticlink.com/nieuws-en-opinie/">
            <FormattedMessage id="Footer.sailingNews" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.vaarmarkt.nl/vaargids/">
            <FormattedMessage id="Footer.vaargrids" />
          </ExternalLink>
        ),
      },

      {
        link: (
          <ExternalLink href="https://www.nauticlink.com/bootnamen/">
            <FormattedMessage id="Footer.boatNames" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.nauticlink.com/watersportgids-overzicht/">
            <FormattedMessage id="Footer.companyIndex" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.nauticlink.com/watersportgids-overzicht/">
            <FormattedMessage id="Footer.whetherAndNavigation" />
          </ExternalLink>
        ),
      },
    ],
  },
  {
    name: 'Footer.collaborate',
    items: [
      {
        link: (
          <ExternalLink href="https://www.vaarmarkt.nl/de-nieuwsredactie-van-vaarmarkt/">
            <FormattedMessage id="Footer.editorial" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.vaarmarkt.nl/persberichten-plaatsen-op-vaarmarkt/">
            <FormattedMessage id="Footer.pressReleases" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href=" https://www.vaarmarkt.nl/contact/">
            <FormattedMessage id="Footer.contact" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <ExternalLink href="https://www.vaarmarkt.nl/adverteren-op-vaarmarkt/">
            <FormattedMessage id="Footer.advertising" />
          </ExternalLink>
        ),
      },
    ],
  },
  {
    name: 'Footer.forSellers',
    items: [
      {
        link: (
          <ExternalLink href="https://www.nauticlink.com/">
            <FormattedMessage id="Footer.pricing" />
          </ExternalLink>
        ),
      },
      {
        link: (
          <NamedLink name="TermsOfServicePage">
            <FormattedMessage id="Footer.termsAndConditions" />
          </NamedLink>
        ),
      },
    ],
  },
];

export const bottomFooterSection = [
  {
    link: (
      <NamedLink name="PrivacyPolicyPage">
        <FormattedMessage id="Footer.privacyPolicy" />
      </NamedLink>
    ),
  },

  {
    link: (
      <ExternalLink href="https://www.nauticlink.com/Privacyverklaring/">
        <FormattedMessage id="Footer.cookies" />
      </ExternalLink>
    ),
  },
];
